<template>
  <div v-loading="$wait.waiting(_uid)" class="card create-group">
    <div class="card-content">
      <form @submit.prevent="createGroup">
        <div class="row">
          <div class="col-xs-12">
            <div class="text-right wrapper-button control-button-wrapper">
              <router-link :to="{ name: 'companies_groups@index' }">
                <button
                  type="button"
                  class="btn btn-cancel btn-primary btn-wd submit-button"
                >
                  Cancel
                </button>
              </router-link>
              <button class="btn btn-info btn-fill btn-wd submit-button">
                Create
                <i
                  v-show="$wait.waiting(_uid)"
                  class="fas fa-circle-notch loading-icon"
                />
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <h5 class="title text-info mt-xxs">
              <b> Name </b>
            </h5>
            <fg-input
              v-model="model.name"
              type="text"
              placeholder="Name"
              required
            />
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="card-header pt-xxxs">
            <h5 class="title text-info">
              <b> Training Manager </b>
            </h5>
          </div>
          <div class="col-md-6 col-xs-12">
            <div class="form-group text-left">
              <ul class="list-unstyled">
                <li v-for="manager in managers" :key="manager.fullName">
                  <div class="wrapper-switch mr-xs">
                    <p-switch
                      :value="model.managers.includes(manager.id)"
                      type="primary"
                      name="notification"
                      @input="toggleManager(manager.id)"
                    />
                    {{ manager.fullName }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr />

        <div class="row mb-s pb-s">
          <div class="card-header pt-xxxs">
            <h5 class="title text-info">
              <b> Add trainees </b>
            </h5>
          </div>
          <div class="col-xs-12">
            <div class="form-group text-left">
              <div class="mt-s">
                <div class="mb-5 w-full">
                  <fieldset>
                    <div class="form-group">
                      <input
                        v-model="searchQuery"
                        type="search"
                        class="form-control form-search"
                        placeholder="Type to find what you are looking for"
                        aria-controls="datatables"
                        autofocus
                      />
                    </div>
                  </fieldset>
                </div>

                <div>
                  <el-table
                    ref="multipleTable"
                    :data="queriedData"
                    :default-sort="defaultSort"
                    border
                    stripe
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    @row-click="clickRow"
                  >
                    <el-table-column
                      fixed
                      label="Add"
                      type="selection"
                      width="80"
                    />

                    <el-table-column
                      v-for="column in tableColumns"
                      :key="column.label"
                      sortable
                      :sort-orders="['ascending', 'descending']"
                      fixed
                      :min-width="column.minWidth"
                      :prop="column.prop"
                      :label="column.label"
                      :class-name="column.label"
                    />
                  </el-table>
                </div>

                <!-- <div class="flex justify-between items-center">
              <div>
                <p class="category">
                  Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
              </div>

              <p-pagination
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
              />

              <div>
                <el-select
                  v-model="pagination.perPage"
                  class="select-default"
                  placeholder="Per page"
                >
                  <el-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    class="select-default"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </div>
            </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="clearfix mb-s" />
      </form>
    </div>
  </div>
</template>
<script>
import PSwitch from "@components/UIComponents/Switch.vue";
//import PPagination from "@components/UIComponents/Pagination.vue";
import { Table, TableColumn } from "element-ui";
import _xor from "lodash.xor";
import Vue from "vue";
import tableConfig from "@providers/table";
import joinByName from "@helpers/joinByName";
import { mapGetters, mapActions } from "vuex";

Vue.use(Table);
Vue.use(TableColumn);
export default {
  components: {
    PSwitch,
    //PPagination,
  },
  data() {
    const model = {
      name: "",
      managers: [],
      add: [],
      defaultSort: { prop: "fullName", order: "ascending" },
    };

    const table = {
      tableColumns: [
        {
          prop: "fullName",
          label: "Name",
          minWidth: 150,
        },
        // {
        //   prop: "rpe",
        //   label: "Registry, Purpose, Equipment",
        //   minWidth: 200
        // },
        // {
        //   prop: "roles",
        //   label: "Roles",
        //   minWidth: 200
        // }
      ],
    };

    return {
      model,
      ...table,
      ...tableConfig.data,
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("companyGroupStore", ["managers", "trainees"]),
    tableData() {
      return this.trainees.map((trainee) => {
        return {
          ...trainee,
          rpe: joinByName(trainee.company.rpe),
          roles: joinByName(trainee.company.roles),
        };
      });
    },
    ...tableConfig.computed,
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      await this.getManagersAndTrainees();
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    ...mapActions("companyGroupStore", [
      "createCompanyGroup",
      "getManagersAndTrainees",
    ]),
    toggleManager(manager) {
      this.model.managers = _xor(this.model.managers, [manager]);
    },
    handleSelectionChange(val) {
      this.model.add = val;
    },
    // click on the entire row to select
    clickRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    async createGroup() {
      try {
        this.$wait.start(this._uid);

        this.model.add = this.model.add.map((trainee) => {
          return trainee.id;
        });

        const group = await this.createCompanyGroup(this.model);

        return this.$router.push({
          name: "companies_groups@show",
          params: { id: group.id },
        });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/paper/variables";
@import "@/assets/sass/tables";
.btn-cancel {
  margin: 0 12px;
}
.create-group {
  td.Name {
    position: relative;
    z-index: 1;

    .cell {
      color: $info-color;
      font-weight: 600;
      cursor: pointer;
      display: inline;
    }
  }
}

@media (max-width: 1024px) {
  .wrapper-button .btn {
    width: 100%;
  }
  .btn-cancel {
    margin: 12px 0;
  }
}
</style>
